import type { FaireProductEntity } from "../../entity_types/product";

export const p_xhrf5nsrcm: FaireProductEntity = {
  token: "p_xhrf5nsrcm",
  type: "product",
  name: "Mahjong Pouch | Mahjong Social Club Mahjong gift Tyvek",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/769c4253bd0b5bf951253bda04dd3f89da80f045670f9bf3c76e165c621ba63b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/662adb233da08b2dff1040c332d6ec3ea8385026712b48f95bdb51e19829ac9e.jpeg",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
    "https://cdn.faire.com/fastly/4271a40f8f158ac3a0659647bfbeec13815774c2d5acab51a8e8067b133a7978.jpeg",
  ],
  priceDollars: 8,
  description:
    'Cutest mahjong gift pouch perfect for preppy and colorful gifting, stocking stuffers, gifts for mom, mother\'s day, summer and girlfriend gifting sections. Pink and white stripe color with a watercolor mahjong imprint. Matches and coordinates with our Mahjong line.\n\nMaterial is a high quality Tyvek material-kind of a crinkle outside texture, see pictur\n Inside wipeable waterproof lining.\nSize: 9"x6"\n\nAspen Lane ships out of Denver, CO and is a female-founded small business celebrating 10 years in business in 2024!',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:38.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
